import { createFileRoute, redirect } from '@tanstack/react-router';

import { App } from '@src/layout';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    }
    catch {
      try {
        await auth.refreshToken();
      }
      catch (e) {
        throw redirect({
          to: '/auth/login',
          search: {
            redirect: encodeURIComponent(location.href),
          },
        });
      }
    }
  },
  component: App,
});
